"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NodeSnapShot = void 0;
const node_1 = require("./node");
class NodeSnapShot {
    constructor(startDate, endDate, node) {
        this.startDate = startDate;
        this.endDate = endDate;
        this.node = node;
    }
    toJSON() {
        return {
            startDate: this.startDate,
            endDate: this.endDate,
            node: this.node
        };
    }
    static fromJSON(nodeSnapShot) {
        let snapShotObject;
        if (typeof nodeSnapShot === 'string') {
            snapShotObject = JSON.parse(nodeSnapShot);
        }
        else
            snapShotObject = nodeSnapShot;
        return new NodeSnapShot(new Date(snapShotObject.startDate), new Date(snapShotObject.endDate), node_1.Node.fromJSON(snapShotObject.node));
    }
}
exports.NodeSnapShot = NodeSnapShot;
//# sourceMappingURL=node-snap-shot.js.map